module.exports = __webpack_public_path__ + "static/gradientOne-01de2b924203c5390b05368eb9c283cf.svg";